import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const MaintenanceApi = createApi({
  reducerPath: "Maintenance",
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_API_URL}/maintenance`,
    prepareHeaders: (headers) => {
      const token = localStorage.getItem("token");
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      headers.set("Accept", "application/json");
      return headers;
    },
  }),
  endpoints: (builder) => ({
    getAllRegularMaintenance: builder.query({
      query: () => ``,
    }),
    createRegularMaintenance: builder.mutation({
      query: ({ body }) => {
        return {
          url: "",
          method: "POST",
          body: body,
        };
      },
    }),
    deleteRegularMaintenance: builder.mutation({
      query: (id) => {
        return {
          url: `/${id}`,
          method: "DELETE",
        };
      },
    }),
    editRegularMaintenance: builder.mutation({
      query: ({ id, body }) => {
        return {
          url: `/${id}`,
          method: "PUT",
          body: body,
        };
      },
    }),
    getMaintenanceByVehicle: builder.query({
      query: (vehicleId) => `?deviceId=${vehicleId}`,
    }),
  }),
});

export const {
  useGetAllRegularMaintenanceQuery,
  useCreateRegularMaintenanceMutation,
  useDeleteRegularMaintenanceMutation,
  useEditRegularMaintenanceMutation,
  useGetMaintenanceByVehicleQuery,
} = MaintenanceApi;
